let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("ffEVr"), load("Wowvf"), load("718G0")]).then(() => parcelRequire('iZY6P'));